// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchBar_input__35An9","button":"SearchBar_button__zjQ9i"};